<script lang="ts" setup>
import { ref, watch, onMounted, reactive } from "vue";
import { usePGRESTAPIStore } from "../store/pgrest_api";
import PGRESTResult from "../classes/PGRESTResult";
import { ElMessage } from "element-plus";
import type { FormInstance } from "element-plus";
import ConfigKad from "../classes/DB_Entities/ConfigKad";
import { useGenericMethodsVariables } from "../composables/genericMethodsVariables";
const { showError } = useGenericMethodsVariables();

const props = defineProps({
  kadid: Number,
});
const klados = ref<any>([]);
const emits = defineEmits(["save", "close", "fail-save"]);
const pgrestapi = usePGRESTAPIStore();
const data = ref(new ConfigKad());
const activeName = ref("first");
const ruleFormRef = ref<FormInstance>();
let isLoading = ref(false);

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate((valid, fields) => {
    if (valid) {
      console.log("submit!");
      save();
    } else {
      console.log("error submit!", fields);
    }
  });
};

watch(
  () => props.kadid,
  async (newVal, oldVal) => {
    // console.log("Loading debtor with id " + props.debtorid);
    await loadKAD(props.kadid as number);
  }
);

onMounted(async () => {
  await loadKAD(props.kadid as number);
  await loadKlados();
});

const close = async () => {
  emits("close");
};

const save = async () => {
  let result: PGRESTResult = new PGRESTResult();

  let id = JSON.stringify(data.value.id);
  delete data.value.id;

  result = await pgrestapi.patch("config_kad?id=eq." + id, data.value);

  if (result.error) {
    showError(result.error.message); // emits("fail-save");
    return;
  }

  emits("save");
};

const loadKAD = async (kad_id: number) => {
  isLoading.value = true;
  if (kad_id === -1) return;

  let result: PGRESTResult = new PGRESTResult();

  result = await pgrestapi.get("config_kad?id=eq." + kad_id);

  if (result.error) {
    showError(result.error.message);

    return;
  }

  data.value = result.data[0];
  isLoading.value = false;
};

const loadKlados = async () => {
  let result: PGRESTResult = new PGRESTResult();

  result = await pgrestapi.get("config_klados?order=kodikos");

  if (result.error) {
    showError(result.error.message);

    return;
  }

  klados.value = result.data;
};
</script>

<template>
  <div>
    <el-form :model="data" ref="ruleFormRef" v-loading="isLoading">
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item :label="$t('PlatformSettingsView.kad_details')">
            <el-input v-model="data.kodikos_kad" autocomplete="off" />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('PlatformSettingsView.description_details')">
            <el-input type="textarea" v-model="data.perigrafi" autocomplete="off" />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('PlatformSettingsView.klados')">
            <el-select v-model="data.klados_id" placeholder=" ">
              <el-option
                v-for="klados_item in klados"
                :key="klados_item.id"
                :label="klados_item.kodikos + ' (' + klados_item.perigrafi + ')'"
                :value="klados_item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div style="display: flex; justify-content: flex-end; width: 100%; padding: 0">
        <el-form-item>
          <el-button type="primary" @click="submitForm(ruleFormRef)">{{$t('generic.save')}}</el-button>
          <el-button @click="close">{{$t('generic.close')}}</el-button>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<style scoped></style>
